import React, { useEffect, useState, useRef } from "react"
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/scss'
import 'swiper/scss/effect-fade'
import useMobileDetect from 'use-mobile-detect-hook'
import ArrowLeft from "images/svg/icons/arrow-left.svg"
import ArrowRight from "images/svg/icons/arrow-right.svg"
import "./slides.scss"

const detectMobile = useMobileDetect()
const isMobile = detectMobile.isMobile()

const Slider = ({
  cardClass,
  has_header,
  header = null,
  numSlides,
  showButtons = true,
  padding,
  title,
  ...props
}) => {
  const [slidesPerView, setSlidesPerView] = useState(numSlides)
  setTimeout(() => {
    setSlidesPerView(numSlides + 0.01)
  }, 200);

  const params = {
    autoHeight: props.autoHeight,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 1.2,
        spaceBetween: 15,
      },
      760: {
        slidesPerView: props.columns === 1
          ? 1.2 // Show one card a little of the next
          : 2.2,
        spaceBetween: 20,
      },
      1040: {
        slidesPerView: props.columns === 1
          ? 1.2 // Show one card a little of the next
          : 3,
        spaceBetween: 24,
      },
    },
    direction: 'horizontal',
    grabCursor: true,
    spaceBetween: padding,
    slidesPerView: slidesPerView,
    rebuildOnUpdate: true, // Fixes 1st render issue
    lazy: { // Correct format for lazy loading
      loadPrevNext: true, // Load previous and next slides
      loadPrevNextAmount: 1, // Number of slides to load
    },
    loop: false,
    pagination: false,
    navigation: false,
    threshold: 20, // Minimum distance (in px) to be swiped to trigger slide change
    touchRatio: 1.5, // Higher value means more sensitive to swipes
    touchReleaseOnEdges: true, // Allow releasing touch on slider edges
  }

  const [swiper, setSwiper] = useState(null)
  const swiperRef = useRef()
  const prevButton = useRef()
  const nextButton = useRef()
  const cards = props?.data || []

  useEffect(() => {
    if (swiperRef.current) {
      setSwiper(swiperRef.current.swiper)
    }
  }, [swiperRef])

  useEffect(() => {
    if (swiper) {
      updateButtons()
      swiper.on("slideChange", () => {
        updateButtons()
        if (props.onChange) {
          try {
            props.onChange(swiper)
          } catch (error) {
            console.log('Problem changing swiper ', error)
          }
        }
      })
    }
  }, [swiper, props])

  const updateButtons = () => {
    if (prevButton.current && nextButton.current) {
      if (swiper.isBeginning) {
        prevButton.current.classList.add("disabled")
      } else {
        prevButton.current.classList.remove("disabled")
      }

      if (swiper.isEnd) {
        nextButton.current.classList.add("disabled")
      } else {
        nextButton.current.classList.remove("disabled")
      }

      if (props.theme === 'light') {
        prevButton.current.classList.add("light")
        nextButton.current.classList.add("light")
      } else {
        prevButton.current.classList.remove("light")
        nextButton.current.classList.remove("light")
      }
    }
  }

  const nextSlide = () => {
    if (swiper) {
      swiper.slideNext()
      if (props.onChange) props.onChange(swiper)
    }
  }

  const prevSlide = () => {
    if (swiper) {
      swiper.slidePrev()
      if (props.onChange) props.onChange(swiper)
    }
  }

  useEffect(() => {
    if (props.goToSlide && swiper && props.goToSlide !== swiper.activeIndex) {
      if (swiper.activeIndex - props.goToSlide !== 1) {
        swiper.slideTo(props.goToSlide, 0)
      }
    }
  }, [props.goToSlide, swiper])

  const sliderContainerStyle = {
    height: `100%`,
  }

  const styleSwiperButtons = { display: has_header ? 'inline' : 'inline-block' }
  const classButtons = `swipper-buttons ${has_header ? 'has__header' : ''}`

  const SwiperButtons = (
    <div className='swipper-buttons' style={styleSwiperButtons}>
      <button
        ref={prevButton}
        onClick={prevSlide}
        className="button swiper-button swiper-button-prev">
        <ArrowLeft />
      </button>
      <button
        ref={nextButton}
        onClick={nextSlide}
        className="button swiper-button swiper-button-next">
        <ArrowRight />
      </button>
    </div>
  )

  return (
    <div className={'slider ui ' + props.style} style={sliderContainerStyle}>
      {!isMobile && showButtons ? SwiperButtons : null}
      {header ? <h4 style={{ display: 'inline' }}>{header}</h4> : null}
      <Swiper ref={swiperRef} {...params}>
        {cards.map((item, i) => (
          <SwiperSlide key={i} className={`swiper-slide-singCardPost ${cardClass ? cardClass : ''} ${cards?.length === 1 ? 'single' : 'cards-' + cards?.length}`}>
            {item}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

Slider.defaultProps = {
  autoHeight: true,
  data: [
    <div>Slide 1</div>,
    <div>Slide 2</div>,
    <div>Slide 3</div>,
    <div>Slide 4</div>
  ],
  columns: 3,
  numSlides: isMobile ? 1.25 : 3,
  padding: 20,
  style: 'carousel',
  theme: 'dark'
}

export default Slider